





























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ScenarioAssignmentConfirmModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly dialog!: boolean;

  @Prop({ type: String, default: '' }) readonly element!: string;

  @Prop({ type: String, default: '' }) readonly scenarioName!: string | null;

  confirm() {
    this.$emit('confirm');
  }

  discard() {
    this.$emit('discard');
  }
}
